(() => {
  if (window.infoBadgesReady) return;
  window.infoBadgesReady = true;

  const open = (dialog) => {
    if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-info-badge-open]');
    if (opener) {
      open(document.getElementById(opener.dataset.infoBadgeOpen));
      return;
    }

    const closer = event.target.closest('[data-info-badge-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }

    // Klick på den mörka bakgrunden utanför rutan stänger popupen.
    if (event.target.matches('dialog.info-badge-dialog')) event.target.close();
  });

  // I temaredigeraren: visa popupen när ikonen är vald så att innehållet går att förhandsgranska.
  document.addEventListener('shopify:block:select', (event) => {
    open(event.target.querySelector('dialog.info-badge-dialog'));
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const dialog = event.target.querySelector('dialog.info-badge-dialog');
    if (dialog && dialog.open) dialog.close();
  });
})();
